var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1704189478968,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 6712,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M599.154026 511.920262a103.048539 103.048539 0 0 1 22.565955-64.242538l225.686134-282.140892a23.762031 23.762031 0 0 0 5.315891-14.831334V109.587084a23.762031 23.762031 0 0 0-23.762031-23.762031H195.252661a23.762031 23.762031 0 0 0-23.762031 23.762031v41.171572a23.682292 23.682292 0 0 0 5.31589 14.751597l225.739293 282.140892a103.101698 103.101698 0 0 1 22.565956 64.295696V830.607901a23.682292 23.682292 0 0 0 13.10367 21.263562l161.124643 80.588901V511.920262zM195.146343 6.698022h633.574417a102.99538 102.99538 0 0 1 102.942221 102.942221v41.171572a103.048539 103.048539 0 0 1-22.565956 64.242538l-225.446919 282.167471a23.762031 23.762031 0 0 0-5.31589 14.831335v433.245081a71.286093 71.286093 0 0 1-103.154857 63.790687l-172.580387-86.303483a102.942221 102.942221 0 0 1-56.906608-92.071225V512.053159a23.762031 23.762031 0 0 0-5.315891-14.831335L114.849816 215.027773a102.942221 102.942221 0 0 1-22.565956-64.295696V109.613663A102.99538 102.99538 0 0 1 195.226081 6.671443z",
    "p-id": 6713
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.97e3dadc.svg";
export { ForwardRef as ReactComponent };